export default __webpack_public_path__ + "static/media/plug.3e1ac199.svg";